var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81124 2.3L7.08424 1.11198L7.22487 0.5H6.59694H4.52879H4.13066L4.04149 0.888021L3.71702 2.3H1.82726H1.32726V2.8V4.67297V5.17297H1.82726H3.07521L2.94044 5.76622H1H0.5V6.26622V8.13919V8.63919H1H2.28546L1.99913 9.88828L1.8589 10.5H2.48649H4.55464H4.95299L5.042 10.1117L5.37955 8.63919H6.49933L6.21299 9.88828L6.07277 10.5H6.70035H8.76851H9.16686L9.25587 10.1117L9.59342 8.63919H11.1727H11.6727V8.13919V6.26622V5.76622H11.1727H10.2479L10.3827 5.17297H12H12.5V4.67297V2.8V2.3H12H11.0251L11.2981 1.11198L11.4387 0.5H10.8108H8.74266H8.34452L8.25536 0.888021L7.93089 2.3H6.81124ZM6.03408 5.76622L6.16884 5.17297H7.28907L7.15431 5.76622H6.03408Z",
    stroke: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC19);
export default __webpack_public_path__ + "static/media/c19.246ec3ad3bf2620b5990035e4fb85cc0.svg";
export { ForwardRef as ReactComponent };